const LABEL_WIDTH = 130
const KEYFRAME_DIAMETER = 8
const CSS_ROTATION_OFFSET = KEYFRAME_DIAMETER / 2

export {
  LABEL_WIDTH,
  KEYFRAME_DIAMETER,
  CSS_ROTATION_OFFSET,
}
